import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-header',
    templateUrl: './modal-header.component.html',
})
export class ModalHeaderComponent {
    @Input() modalTitle?: string;
    @Output() modalClosed = new EventEmitter();

    constructor(public activeModal: NgbActiveModal) {}

    onClose() {
        this.activeModal.dismiss();
        this.modalClosed.emit();
    }
}
